export default "__VITE_ASSET__b29d8946__"